<question-wrapper [title]="title">
  <div class="ic-question-yesno">
    <div class="ic-question-yesno__controls">
      @for (option of options; track option) {
      <button
        class="iconf-btn-blank minw150 margin-border minh40"
        [ngClass]="{ selected: isCurrentAnswer(option) }"
        (click)="onValueChange(option)"
      >
        {{ option.label }}
      </button>
      }
    </div>
  </div>
</question-wrapper>
